import { useState } from 'react';

const countries = ['United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'France', 'Japan', 'South Korea'];
const weights = ['0.5 kg', '1 kg', '2 kg', '3 kg', '5 kg', '10 kg'];
const methods = ['Air Mail (Economy)', 'E-EMS', 'EMS', 'DHL Express', 'FedEx', 'UPS', 'Sea Mail'];

export default function ShippingSection() {
  const [country, setCountry] = useState('');
  const [weight, setWeight] = useState('');
  const [method, setMethod] = useState('');

  return (
    <section id="shipping" className="relative py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <span className="inline-block bg-secondary-100 text-secondary-800 text-xs font-semibold px-3 py-1 rounded-full mb-4 whitespace-nowrap">
              Shipping Guide
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
              Sugargoo Shipping Cost Explained 2026
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              Shipping costs through Sugargoo depend on several key factors. Understanding these variables helps you budget accurately and choose the most cost-effective delivery method for your orders.
            </p>

            <div className="space-y-4 mb-6">
              {[
                { label: 'Package Weight', desc: 'Heavier packages naturally cost more to ship internationally.' },
                { label: 'Destination Country', desc: 'Shipping rates vary significantly between regions and countries.' },
                { label: 'Shipping Method', desc: 'Express couriers are faster but more expensive than standard options.' },
                { label: 'Insurance Coverage', desc: 'Optional insurance adds a small percentage to protect your package.' },
                { label: 'Package Dimensions', desc: 'Volumetric weight may apply for oversized or bulky items.' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-700 text-xs"></i>
                  </div>
                  <div>
                    <strong className="text-sm text-foreground-800 font-semibold">{item.label}</strong>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-7">
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-5 text-center">
                Estimate Your Shipping
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-xs font-semibold text-foreground-700 mb-1.5 whitespace-nowrap">
                    Destination Country
                  </label>
                  <select
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    className="w-full bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors"
                  >
                    <option value="">Select country</option>
                    {countries.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-foreground-700 mb-1.5 whitespace-nowrap">
                    Package Weight
                  </label>
                  <select
                    value={weight}
                    onChange={(e) => setWeight(e.target.value)}
                    className="w-full bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors"
                  >
                    <option value="">Select weight</option>
                    {weights.map((w) => (
                      <option key={w} value={w}>{w}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-foreground-700 mb-1.5 whitespace-nowrap">
                    Shipping Method
                  </label>
                  <select
                    value={method}
                    onChange={(e) => setMethod(e.target.value)}
                    className="w-full bg-background-50 border border-background-300/60 rounded-md px-4 py-2.5 text-sm text-foreground-800 focus:outline-none focus:border-primary-400 transition-colors"
                  >
                    <option value="">Select method</option>
                    {methods.map((m) => (
                      <option key={m} value={m}>{m}</option>
                    ))}
                  </select>
                </div>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="block w-full bg-accent-500 text-background-50 text-center py-3 rounded-md text-sm font-semibold hover:bg-accent-600 transition-all whitespace-nowrap mt-2"
                >
                  Check Latest Shipping Info
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}